import options from './touch.component';


export default {
    selector: "dtEmulatorTouch",
    options
}